import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ClockIcon, UsersIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden" id="hero" data-id="element-52">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-53">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-54">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-55">
            <div className="inline-flex items-center space-x-2 px-3 py-1 rounded-full bg-sage-light text-sage text-sm font-medium mb-8" data-id="element-56">
              <span className="relative flex h-2 w-2" data-id="element-57">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sage opacity-75" data-id="element-58"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-sage" data-id="element-59"></span>
              </span>
              <span data-id="element-60">Digital Download Available Instantly</span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-semibold tracking-tight leading-[1.1] mb-6" data-id="element-61">
              Reclaim Your Energy. <br className="hidden md:block" data-id="element-62" />
              <span className="italic text-sage" data-id="element-63">Melt Stress Fat.</span>
            </h1>

            <p className="text-lg md:text-xl text-teal-muted mb-10 leading-relaxed max-w-xl" data-id="element-64">
              The 7-day science-backed protocol for busy professional women to
              balance hormones and eliminate bloating.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-65">
              <a href="#get-access" className="inline-flex justify-center items-center px-8 py-4 text-base font-medium text-white bg-sage hover:bg-sage-hover transition-colors duration-200 rounded-none w-full sm:w-auto" data-id="element-66">
                Get the Reset for $6.36
              </a>
            </div>

            <div className="grid grid-cols-3 gap-4 border-t border-cream-dark pt-8" data-id="element-67">
              <div className="flex flex-col items-center text-center space-y-2" data-id="element-68">
                <ClockIcon className="w-5 h-5 text-sage" data-id="element-69" />
                <span className="text-xs text-teal-muted font-medium uppercase tracking-wider" data-id="element-70">
                  Instant Access
                </span>
              </div>
              <div className="flex flex-col items-center text-center space-y-2" data-id="element-71">
                <ShieldCheckIcon className="w-5 h-5 text-sage" data-id="element-72" />
                <span className="text-xs text-teal-muted font-medium uppercase tracking-wider" data-id="element-73">
                  30-Day Guarantee
                </span>
              </div>
              <div className="flex flex-col items-center text-center space-y-2" data-id="element-74">
                <UsersIcon className="w-5 h-5 text-sage" data-id="element-75" />
                <span className="text-xs text-teal-muted font-medium uppercase tracking-wider" data-id="element-76">
                  10k+ Women
                </span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative lg:ml-auto w-full max-w-lg mx-auto lg:max-w-none" data-id="element-77">
            <div className="aspect-[4/5] relative bg-cream-dark overflow-hidden" data-id="element-78">
              <img src="https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=2420&auto=format&fit=crop" alt="Woman stretching in natural light, feeling energized and calm" className="absolute inset-0 w-full h-full object-cover" data-id="element-79" />
              <div className="absolute inset-0 border-4 border-cream m-4 mix-blend-overlay" data-id="element-80"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}